// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1SvVE","title":"Header_title__zEOug","left":"Header_left__1-_4r","clinicName":"Header_clinicName__AsPEn"};